<template>
  <dialogue-modal
    title="Do you want to print the invoice?"
    :message="invoiceDetails.invoiceNo"
    :buttons="buttons"
  />
  <loading-modal v-if="loading" />
  <div
    v-else
    :id="invoiceDetails.invoiceNo"
    class="justify-content-center bg-white p-3"
  >
    <div
      v-if="
        invoiceDetails.billerID === 1 && invoiceDetails.type === 'consignment'
      "
      class="text-center"
      style="margin-bottom: 20px"
      bis_skin_checked="1"
    >
      <img src="/images/consignment.png" alt="Consignment Invoice" />
    </div>
    <div
      v-else-if="invoiceDetails.billerID !== 1"
      class="text-center"
      style="margin-bottom: 20px"
      bis_skin_checked="1"
    >
      <img
        :src="`/images/${invoiceDetails.billerLogo}`"
        :alt="invoiceDetails.biller"
      />
      <br />
      {{ invoiceDetails.fullBillerAddress }} <br />
      {{ invoiceDetails.billerPhone }}
    </div>
    <div class="row m-1 mb-2 mt-0" style="font-size: 10px" bis_skin_checked="1">
      <div class="col-6" bis_skin_checked="1">
        <p class="mb-2"><strong>To:</strong></p>
        <p class="fs-18 mb-2">
          <strong> {{ invoiceDetails.customer }} </strong>
        </p>
        <p class="mb-2">
          <strong> {{ invoiceDetails.fullCustomerAddress }}</strong>
        </p>
      </div>
      <div class="col"></div>
      <div class="col-2 px-2" bis_skin_checked="1">
        <p class="mb-2 fs-12">
          <strong>
            Date: {{ this.dateFormat(invoiceDetails.date) }}<br />
            <span class="fs-18"> Invoice No: </span>
            <br />
            <span class="fs-18">
              {{ invoiceDetails.invoiceNo.split("Invoice/")[1] }}
            </span>
            <br />
          </strong>
        </p>
      </div>
    </div>

    <div class="table-responsive" bis_skin_checked="1">
      <table
        class="table table-hover print-table order-table"
        style="border-color: darkgrey"
      >
        <thead style="border-color: darkgrey">
          <tr>
            <th>No</th>
            <th>Qty</th>
            <th>Description</th>
            <th>Barcode</th>

            <th>Unit Price</th>
            <th>Subtotal</th>
            <th :colspan="invoiceDetails.showSuggestedAnalysis + 1">
              Sugg Price
            </th>
            <th
              v-if="invoiceDetails.showIndividualMargin"
              style="text-align: center"
            >
              %
            </th>
          </tr>
        </thead>

        <tbody>
          <template v-for="(row, index) in displayedRows" :key="index">
            <tr v-if="row.type == 'line'">
              <td
                style="text-align: center; width: 30px; vertical-align: middle"
              >
                {{ row.number }}
              </td>
              <td
                style="width: 40px; text-align: center; vertical-align: middle"
              >
                {{ row.quantity }}
              </td>
              <td
                style="width: 400px; text-align: left; vertical-align: middle"
              >
                {{ row.productName }}
              </td>

              <td
                style="width: 130px; text-align: center; vertical-align: middle"
              >
                <img
                  width="115"
                  height="32"
                  :src="`/images/barcodes/${row.barcode}.png`"
                  :alt="row.barcode"
                />
              </td>

              <td style="text-align: right; width: 100px">
                {{ priceFormat(row.sellingPrice) }}
              </td>
              <td style="text-align: right; width: 80px">
                {{ priceFormat(row.subtotal) }}
              </td>
              <td
                :colspan="invoiceDetails.showSuggestedAnalysis + 1"
                style="text-align: right; width: 30px"
              >
                {{ priceFormat(row.suggestedRetailPrice) }}
              </td>
              <td
                v-if="invoiceDetails.showIndividualMargin"
                style="text-align: right; width: 60px"
              >
                {{
                  percentageFormat(
                    (1 - row.sellingPrice / row.suggestedRetailPrice) * 100
                  )
                }}
              </td>
            </tr>
            <tr v-else-if="row.type == 'subtotal'" class="bg-light">
              <td></td>
              <td
                style="
                  width: 40px;
                  text-align: center;
                  vertical-align: middle;
                  font-weight: bold;
                "
                class="bg-light"
              >
                {{ row.quantity }}
              </td>
              <td
                colspan="1"
                style="text-align: left; font-weight: bold"
                class="bg-light"
              >
                SOLD
              </td>
              <td
                colspan="2"
                style="text-align: right; font-weight: bold"
                class="bg-light"
              >
                Subtotal
              </td>
              <td
                style="text-align: right; width: 80px; font-weight: bold"
                class="bg-light"
              >
                {{ priceFormat(row.subtotal) }}
              </td>
              <td
                :colspan="invoiceDetails.showSuggestedAnalysis + 1"
                class="bg-light"
              ></td>
              <td
                v-if="invoiceDetails.showIndividualMargin"
                class="bg-light"
              ></td>
            </tr>
          </template>
        </tbody>

        <tfoot style="display: table-row-group">
          <tr v-for="(value, key, index) in invoiceDetailsFooter" :key="index">
            <template v-if="index === 0">
              <td></td>
              <td style="text-align: center; font-weight: bold">
                {{ data.reduce((sum, item) => sum + item.quantity, 0) }}
              </td>
              <td colspan="3" style="text-align: right; font-weight: bold">
                {{ key }}
              </td>
            </template>
            <template v-else>
              <td colspan="5" style="text-align: right; font-weight: bold">
                {{ key }}
              </td>
            </template>
            <td style="text-align: right; font-weight: bold">
              {{ value }}
            </td>
            <template v-if="index < Object.keys(suggestedAmountFooter).length">
              <td
                :colspan="invoiceDetails.showIndividualMargin === 0 ? 1 : 2"
                style="text-align: right; font-weight: bold"
              >
                {{ Object.keys(suggestedAmountFooter)[index] }}
              </td>
              <td style="text-align: right; font-weight: bold">
                {{
                  suggestedAmountFooter[
                    Object.keys(suggestedAmountFooter)[index]
                  ]
                }}
              </td>
            </template>
            <template v-else>
              <td
                :colspan="
                  invoiceDetails.showSuggestedAnalysis +
                  invoiceDetails.showIndividualMargin +
                  1
                "
                style="text-align: right; font-weight: bold"
              ></td>
            </template>
          </tr>
        </tfoot>
      </table>
    </div>

    <div class="row" bis_skin_checked="1">
      <div class="col-xs-12" bis_skin_checked="1"></div>
    </div>
    <div v-if="invoiceDetails.notes" class="mt-4">
      <div class="alert alert-info">
        <p class="mb-0">
          <span class="fw-semibold">Notes For Customer: </span>
          <span id="note">
            {{ invoiceDetails.notes }}
          </span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingModal from "@/components/utils/LoadingModal";
import DialogueModal from "@/components/utils/modals/DialogueModal";
import { CONFIG } from "@/constants/config";

export default {
  name: "InvoicePrintView.vue",
  components: {
    DialogueModal,
    LoadingModal,
  },
  data() {
    return {
      id: -1,
    };
  },
  computed: {
    data() {
      return this.$store.getters.invoice;
    },
    displayedRows() {
      const src = this.data || [];
      const rows = [];
      let acc = null;
      let number = 1;

      const pushSubtotalIfAny = (acc) => {
        if (!acc) return;
        if (this.invoiceDetails.type === "consignment") {
          rows.push({
            type: "subtotal",
            barcode: acc.barcode,
            quantity: acc.quantity,
            sellingPrice: acc.sellingPrice,
            subtotal: acc.subtotal,
            suggestedRetailPrice: acc.suggestedRetailPrice,
          });
        }
        acc = null;
        return acc;
      };

      for (const line of src) {
        if (!acc || acc.barcode !== line.barcode) {
          acc = pushSubtotalIfAny(acc);
          acc = {
            barcode: line.barcode,
            count: 0,
            quantity: 0,
            sellingPrice: 0,
            subtotal: 0,
            suggestedRetailPrice: 0,
          };
        }
        rows.push({ type: "line", number: number++, ...line });
        acc.count += 1;
        acc.quantity += Number(line.quantity || 0);
        acc.sellingPrice += Number(line.sellingPrice || 0);
        acc.subtotal += Number(line.subtotal || 0);
        acc.suggestedRetailPrice += Number(line.suggestedRetailPrice || 0);
      }
      acc = pushSubtotalIfAny(acc);
      return rows;
    },
    invoiceDetails() {
      return this.$store.getters.invoiceSummary;
    },
    invoiceTotals() {
      return this.$store.getters.invoiceTotals;
    },
    invoiceDetailsFooter() {
      let footer = {
        "Total Amount": this.priceFormat(this.invoiceTotals.total),
        "Total Credit": this.priceFormat(this.invoiceTotals.amountCredited),
        "Redeemed Discount Value": this.priceFormat(
          this.invoiceTotals.discountRedeemed
        ),
        "Redeemed Points Value": "$0.00",
        "Total Paid": this.priceFormat(this.invoiceTotals.paid),
        "Total Balance": this.priceFormat(this.invoiceTotals.balance),
      };
      if (footer["Amount Credited"] === "$0.00") {
        delete footer["Amount Credited"];
      }
      if (footer["Redeemed Discount Value"] === "$0.00") {
        delete footer["Redeemed Discount Value"];
      }
      if (footer["Redeemed Points Value"] === "$0.00") {
        delete footer["Redeemed Points Value"];
      }
      return footer;
    },
    suggestedAmountFooter() {
      if (this.invoiceDetails.showSuggestedAnalysis === 0) {
        return {};
      }
      return {
        "Total Sugg": this.priceFormat(this.invoiceTotals.totalSuggested),
        "Sugg Credit": this.priceFormat(this.invoiceTotals.suggestedCredited),
        Margin: this.percentageFormat(
          parseFloat(this.invoiceTotals.totalSuggestedProfit)
        ),
        "Sugg Balance": this.priceFormat(this.invoiceTotals.suggestedBalance),
      };
    },
    loading() {
      return !this.invoiceDetails;
    },
    buttons() {
      return {
        Back: {
          class: "btn-light",
          function: () => this.$router.push("/invoices"),
        },
        Print: {
          class: "btn-success px-3",
          function: () => window.print(),
        },
      };
    },
    host() {
      return CONFIG.HOST;
    },
  },
  methods: {
    dateFormat(date) {
      let parts = date.split("-");
      let formattedDate = parts[1] + "-" + parts[2] + "-" + parts[0];
      return formattedDate;
    },
    priceFormat(price) {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(price);
    },
    percentageFormat(value) {
      return value.toFixed(2) + "%";
    },
  },
  async created() {
    this.id = parseInt(this.$route.params.id);
    await this.$store.dispatch("getInvoice", this.id);
    await this.$store.dispatch("getInvoiceItems", {
      id: this.id,
      filter: null,
    });
    window.print();
    // window.onafterprint = () => {
    //   this.$router.go(-1);
    //   window.onafterprint = null;
    // };
  },
  async beforeUnmount() {
    await this.$store.dispatch("resetInvoice");
    await this.$store.dispatch("resetBiller");
    await this.$store.dispatch("resetCustomer");
  },
};
</script>

<style scoped>
@media print {
  table {
    font-size: 11pt;
  }
}
</style>
